import { Alert, Button, CircularProgress, Dialog, DialogContent, DialogContentText } from '@mui/material';
import React from 'react';

import { Lab } from 'api/labs';
import { DialogChromeFooter, DialogChromeHeader } from 'components/atoms/Dialog/DialogChrome';

interface DeleteLabDialogProps {
  deletingLab: Lab | null;
  isDeleting: boolean;
  isError: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

export const DeleteLabDialog: React.FC<DeleteLabDialogProps> = ({
  deletingLab,
  isDeleting,
  isError,
  onCancel,
  onConfirm,
}) => {
  return (
    <Dialog
      open={deletingLab !== null}
      onClose={onCancel}
      aria-labelledby="delete-lab-dialog-title"
      data-testid="delete-lab-dialog"
    >
      <DialogChromeHeader
        title="Delete Lab"
        titleId="delete-lab-dialog-title"
        closeButtonAriaLabel="Close delete lab dialog"
        onClose={onCancel}
      />
      <DialogContent dividers>
        {isError && (
          <Alert severity="error" sx={{ mb: 2 }} data-testid="delete-lab-dialog-error">
            Failed to delete lab. Please try again.
          </Alert>
        )}
        <DialogContentText>
          Are you sure you want to delete <strong>{deletingLab?.name || `lab ${deletingLab?.id}`}</strong>?
        </DialogContentText>
      </DialogContent>
      <DialogChromeFooter>
        <Button onClick={onCancel} disabled={isDeleting} data-testid="delete-lab-cancel-button">
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          color="error"
          variant="contained"
          disabled={isDeleting}
          data-testid="delete-lab-confirm-button"
          startIcon={isDeleting ? <CircularProgress size={16} /> : undefined}
        >
          {isDeleting ? 'Deleting…' : 'Delete'}
        </Button>
      </DialogChromeFooter>
    </Dialog>
  );
};
